export default __webpack_public_path__ + "static/media/view.9acee81a.svg";